import { render } from "./ViewRequestHistory.vue?vue&type=template&id=6fea7452"
import script from "./ViewRequestHistory.vue?vue&type=script&lang=js"
export * from "./ViewRequestHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__